const MainRegister = {
  id: 1,
  titleBig: "填写手机号",
  titleSmall: "更好的记录宝宝的学习轨迹",
  inputOne: {
    placeholder: "请输入手机号",
    className: "phone",
    id: "phone",
    errmsg: "该手机号已绑定其他微信，请更换手机号"
  },
  buttonText: {
    content: "下一步",
    updateState: "CodeRegister"
  },
  tips: {},
  statement: "我已阅读并同意《用户协议》与《隐私协议》",
  signWith: false
};

const CodeRegister = {
  id: 2,
  titleBig: "快速注册",
  titleSmall: "短信验证码已发送至 ",
  inputOne: {
    placeholder: "短信验证码",
    className: "message-code",
    id: "messageCode",
    errmsg: "验证码错误"
  },
  inputTwo: {
    placeholder: "至少6位数字、字母组合",
    className: "password",
    id: "password",
    errmsg: "至少6位数字、字母组合"
  },
  buttonText: {
    content: "注册",
    linkto: "",
    updateState: "RegisterSuccess",
    onClick: true
  },
  signWith: false,
  hasPhone: true
};

const RegisterSuccess = {
  id: 3,
  titleBig: "恭喜您，注册成功",
  buttonText: {
    content: "首页",
    linkto: "/login"
  },
  success: true
};

export const RegisterData = {
  MainRegister,
  CodeRegister,
  RegisterSuccess
};



// WEBPACK FOOTER //
// ./src/utils/Register.js